<template>
  <div class="modal-container">
    <div v-if="isOpen" @click.self="close" class="modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" class="close" v-on:click="close">
              <span>&times;</span>
            </button>
          </div>
          <template v-if="status == 'confirm'">
            <div class="modal-body">
              {{ text }}
            </div>
            <div class="modal-footer">
              <button @click="close" type="button" class="btn btn-secondary">
                {{ $t("modal.cancel") }}
              </button>
              <button
                @click="confirm"
                type="button"
                class="btn btn-primary action"
              >
                <template>{{ $t("modal.confirm") }}</template>
              </button>
            </div>
          </template>
          <template v-else-if="status == 'loading'">
            <div class="modal-body">
              <div class="sending-loader">
                <i class="fa fa-paper-plane sending"></i>
                <p class="loading">{{ $t("supplier.sending") }}</p>
                <p class="sent-items">
                  {{
                    $t("supplier.sent", {
                      count: lettersSent,
                      total: lettersCount,
                    })
                  }}
                </p>
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="$emit('stop')"
                type="button"
                class="btn btn-secondary"
              >
                {{ $t("modal.stop") }}
              </button>
            </div>
          </template>
          <div v-else>
            <p>
              {{
                $t("supplier.sent", { count: lettersSent, total: lettersCount })
              }}
            </p>
            <p>{{ $t("supplier.failedSent") }} {{ failedCount }}</p>
            <div class="modal-footer">
              <button
                @click="close"
                type="button"
                class="btn btn-primary action"
              >
                <template>{{ $t("modal.confirm") }}</template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue from "vue";
import { mapGetters } from "vuex";
export default {
  props: [
    "title",
    "text",
    "isOpen",
    "loading",
    "lettersSent",
    "lettersCount",
    "status",
  ],
  computed: {
    failedCount: function () {
      if (this.lettersSent === "?") {
        return this.$t("supplier.checkListing");
      } else {
        return this.lettersCount - this.lettersSent;
      }
    },
  },
  methods: {
    close: function () {
      this.$emit("close");
    },
    save: function () {
      this.callback(this.value);
    },
    confirm: function () {
      this.$emit("confirm", true);
    },
  },
  data() {
    return {
      value: "",
      modals: [],
      type: "",
      callback: null,
    };
  },
};
</script>

<style scoped>
.sent-items {
  position: absolute;
  bottom: 0px;
  left: 40px;
}
.action {
  width: 6rem;
}
.modal-error {
  color: red;
  font-weight: bold;
}
.modal-title {
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 4; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  color: #212529;
}

.modal-content {
  background-color: #fefefe;
  margin: 20% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  max-width: 650px; /* Could be more or less, depending on screen size */
  box-shadow: 5px 5px 15px hsla(0, 0%, 0%, 0.4);
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.modal-select > input[type="modal"] {
  display: none;
}

.sending {
  animation: fly 1300ms ease;
  animation-iteration-count: infinite;
}
.fa {
  position: absolute;
  top: 10px;
  left: 70px;
  font-size: 30px;
  color: #296c7e;
}
.sending-loader {
  position: relative;
  height: 140px;
  margin: auto;
  background: #fff;
  width: 200px;
}
@keyframes fly {
  0% {
    opacity: 0;
    transform: translate(0px, 0px);
  }

  40% {
    transform: translate(0px, 0px);
    opacity: 1;
  }
  100% {
    transform: translate(40px, -40px);
    opacity: 0;
  }
}
.loading:after {
  content: ".";
  animation: dots 2s steps(5, end) infinite;
}
.loading {
  color: hsla(191, 44%, 38%, 0.8);
  position: absolute;
  bottom: 40px;
  left: 50px;
}

@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: hsla(191, 44%, 38%, 0.8);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 hsla(191, 44%, 38%, 0.8), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80%,
  100% {
    text-shadow: 0.25em 0 0 hsla(191, 44%, 38%, 0.8),
      0.5em 0 0 hsla(191, 44%, 38%, 0.8);
  }
}
@media screen and (max-width: 768px) {
  .modal-content {
    width: 100%;
    margin: 15% auto;
  }
}
</style>
